<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_14"></a><a id="page_15"></a><a id="part1"></a>P<span class="small">ART</span> I: S<span class="small">ELENE</span></h2>
<h2 class="h2a">60, 268 <em>John Glenn</em> shiptime</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?04559826